import { FileImageOutlined } from "@ant-design/icons";
import { Form, Input, Modal, Switch, Select } from "antd";
import { SingleImageUpload } from "components/SingleImageUpload";
import React, { useEffect, useState } from "react";
import ReactQuill from "react-quill";
import { api } from "services/api";
import Swal from "sweetalert2";
// import { IAddNews } from "types";
import { getBase64Img } from "utils";

const { Option } = Select;

export const EditNewsModal: React.FC<any> = ({ ...props }) => {
	const [value, setValue] = useState<string>("");
	const [option, setOption] = useState<string>("");
	const [isActive, setIsActive] = useState<boolean>(false);
	const [imageWasEdited, setImageWasEdited] = useState<boolean>(false);

	const {
		form,
		isOpen,
		setCurrentImgURL,
		setIsOpen,
		newsStatus,
		currentImgURL,
		setNewsStatus,
		newsIsHighlight,
		setNewsIsHighlight,
		onUpdated,
		currentNewsInfo,
	} = props;

	const setIsActiveAndReviewStatus = (isActiveParam: boolean) => {
		setIsActive(isActiveParam)
		if(!isActiveParam) {
			setNewsStatus(false)
		}
	}

	const handleRegister = (values: any) => {
		api
			.put(`/news/${currentNewsInfo?.id}`, values)
			.then((result) => {
				if ([200, 201].includes(result.status)) {
					const {
						data: { feedback },
					} = result;
					onUpdated(result.data)
					Swal.fire({
						icon: "success",
						text: feedback["success"],
						confirmButtonColor: "#63b8cd",
					}).then(() => {
						setIsOpen(false);
						form.resetFields();
						setNewsIsHighlight(false);
						setIsActive(false);
						setNewsStatus(false);
						setCurrentImgURL("");
					});
					const html = document.getElementsByTagName("html");
					html.item(0)?.classList.remove("swal2-shown", "swal2-height-auto");
					document.body.classList.remove("swal2-shown", "swal2-height-auto");
				}
			})
			.catch((err) => {
				const status = err.response.status;
				const { feedback, errors } = err.response?.data;
				if (
					status === 400 ||
					status === 401 ||
					status === 404 ||
					status === 403 ||
					status === 500
				) {
					Swal.fire({
						icon: "error",
						text: feedback["error"]
							? feedback["error"]
							: "Desculpe, ocorreu algum problema =( Por favor tente novamente",
					});
					const html = document.getElementsByTagName("html");
					html.item(0)?.classList.remove("swal2-shown", "swal2-height-auto");
					document.body.classList.remove("swal2-shown", "swal2-height-auto");
				}
				if (status === 422) {
					Swal.fire({
						icon: "error",
						text: errors?.message
							? errors?.message
							: "Desculpe, ocorreu algum problema =( Por favor tente novamente",
					});
					const html = document.getElementsByTagName("html");
					html.item(0)?.classList.remove("swal2-shown", "swal2-height-auto");
					document.body.classList.remove("swal2-shown", "swal2-height-auto");
				}
			});
	};

	useEffect(() => {
		if (isOpen) {
			form.setFieldsValue({
				title: currentNewsInfo?.title,
				description: currentNewsInfo?.description,
				visibility:
					currentNewsInfo?.visibility === "public" ? "public" : "private",
			});
			setOption(
				currentNewsInfo?.visibility === "public" ? "public" : "private"
			);
			setCurrentImgURL(currentNewsInfo?.image ? currentNewsInfo?.image : "");
			setNewsStatus(currentNewsInfo?.status === "publish" ? true : false);
			setNewsIsHighlight(currentNewsInfo?.is_highlight === true ? true : false);
			setIsActive(currentNewsInfo?.is_active === true ? true : false);
		}
		// eslint-disable-next-line
	}, [isOpen]);

	const handleChangeImage = (imageUrl: string) => {
		setImageWasEdited(true)
		setCurrentImgURL(imageUrl)
	} 

	return (
		<Modal
			title={<p style={{ margin: 0 }}>Editar notícia</p>}
			open={isOpen}
			maskClosable={false}
			okText="Editar notícia"
			cancelText="Cancelar"
			onOk={() => {
				form
					.validateFields()
					.then((values: any) => {
						const allValues = imageWasEdited
							? {
									...values,
									content: value,
									image: currentImgURL,
									visibility: option,
									is_active: isActive,
									is_highlight: newsIsHighlight,
									status: newsStatus ? "publish" : "pending",
							  }
							: {
									...values,
									content: value,
									visibility: option,
									is_active: isActive,
									is_highlight: newsIsHighlight,
									status: newsStatus ? "publish" : "pending",
							  };
						handleRegister(allValues);
						setCurrentImgURL("");
					})
					.catch((info: any) => {
						console.log("Validate Failed:", info);
					});
			}}
			onCancel={() => {
				setIsOpen(!isOpen);
				setNewsIsHighlight(false);
				setIsActive(false);
				setNewsStatus(false);
				setCurrentImgURL("");
				form.resetFields();
			}}
			width={700}
		>
			<Form form={form} name="new-course" autoComplete="off" layout="vertical">
				<SingleImageUpload showImgURL={currentImgURL?? undefined} onChange={handleChangeImage}/>

				<div className="row mt-2">
					<Form.Item
						label="Título"
						name="title"
						rules={[
							{
								required: true,
								message: "Título necessário",
							},
						]}
					>
						<Input placeholder="Título da notícia" />
					</Form.Item>
					<Form.Item
						label="Descrição"
						name="description"
						rules={[
							{
								required: true,
								message: "Descrição necessária",
							},
						]}
					>
						<Input placeholder="Descrição da notícia" />
					</Form.Item>

					<div className="col-12 col-md-4">
						<Form.Item
							label="Visibilidade"
							name="visibility"
							rules={[
								{
									required: true,
									message: "Visibilidade necessária",
								},
							]}
						>
							<Select
								placeholder="Visibilidade"
								className="m-news-modal__select"
								value={option}
								onChange={(e) => setOption(e)}
							>
								<Option value="public">Público</Option>
								<Option value="private">Privado</Option>
							</Select>
						</Form.Item>
					</div>
					<div className="col-12 col-md-8">
						<div className="row row-cols-3 pb-3 align-items-center text-center">
							<div>
								<p>Publicado</p>
								<Switch
									disabled={isActive === false}
									checked={newsStatus}
									onClick={(e) => setNewsStatus(e)}
								/>
							</div>
							<div>
								<p>Destacar</p>
								<Switch
									checked={newsIsHighlight}
									onClick={(e) => setNewsIsHighlight(e)}
								/>
							</div>
							<div>
								<p>Ativo</p>
								<Switch checked={isActive} onClick={(e) => setIsActiveAndReviewStatus(e)} />
							</div>
						</div>
					</div>
				</div>

				<div className="m-news-modal__textarea">
					<ReactQuill theme="snow" value={value} onChange={setValue} placeholder="Conteúdo da notícia"/>
				</div>
			</Form>
		</Modal>
	);
};
